<template>
  <Select v-model="stringValue">
    <SelectTrigger class="mb-2 w-full">
      <SelectValue placeholder="Select a count" />
    </SelectTrigger>
    <SelectContent class="z-[99999]">
      <SelectGroup>
        <SelectItem
          v-for="opt in options"
          :key="opt.value"
          :value="opt.value.toString()"
        >
          {{ opt.label }}
        </SelectItem>
      </SelectGroup>
    </SelectContent>
  </Select>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'

const props = defineProps<{
  modelValue: number | null
}>()

const emit = defineEmits<{
  (e: 'update:modelValue', value: number | null): void
  (e: 'change', value: number | null): void
}>()

const options = [
  { label: 'All', value: 0 },
  { label: '1', value: 1 },
  { label: '2', value: 2 },
  { label: '3', value: 3 },
  { label: '4', value: 4 },
  { label: '5', value: 5 }
]

const stringValue = computed({
  get: () => props.modelValue?.toString() ?? '0',
  set: (val: string) => {
    const num = parseInt(val, 10)
    emit('update:modelValue', num)
    emit('change', num)
  }
})
</script>